exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deploy-backup-container[data-v-6fa03bba]{margin:.75rem}.deploy-backup-container>div.img-container[data-v-6fa03bba]{margin:.75rem;display:flex;justify-content:center;align-items:center}.deploy-backup-container>div.img-container>img[data-v-6fa03bba]{width:100px}.deploy-backup-container>button[data-v-6fa03bba]{margin-top:.75rem}", ""]);

// exports
